// extracted by mini-css-extract-plugin
export default {"Main":"Main_Main__SgkNz"};